<template>
  <VModal ref="modal" @modal:hidden="$emit('closed')" disable-backdrop-click>
    <template #default>
      <div class="rounded shadow-xs w-full max-w-lg mx-auto" @click.stop>
        <div class="rounded shadow-lg bg-white overflow-hidden">
          <div class="h-10 bg-white pl-4">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Edit Project Asset</h1>
              </div>
              <div class="flex-none">
                <button
                  class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                  @click="$refs.modal.close()"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                    <path
                      d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                      4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                      4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                      5.636z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="p-12 border-t border-gray-200">
            <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
              <form @submit.prevent="handleSubmit(submit)" class="space-y-12">
                <ValidationProvider name="collection" tag="div" vid="collectionName">
                  <template #default="{ errors }">
                    <BaseFormGroup>
                      <BaseFormLabel for="collection"> Collection </BaseFormLabel>
                      <BaseFormInput
                        id="collection"
                        v-model="formData.collection"
                        :disabled="pending"
                      />
                      <BaseFormInlineMessage v-if="errors.length" danger>
                        {{ errors[0] }}
                      </BaseFormInlineMessage>
                    </BaseFormGroup>
                  </template>
                </ValidationProvider>

                <div class="flex space-x-2">
                  <BaseButton primary :disabled="pending || invalid">
                    Update project asset
                  </BaseButton>

                  <BaseButton type="button" ghost :disabled="pending" @click="$refs.modal.close()">
                    Cancel
                  </BaseButton>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';

export default {
  name: 'EditProjectAssetModal',
  mixins: [veeValidateErrorsMixin],
  props: {
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formData: {},
      pending: false,
    };
  },
  computed: {
    projectAsset() {
      return this.$store.state.entities.projectAssets.byId[this.projectAssetId];
    },
  },
  created() {
    this.formData = {
      collection: this.projectAsset.collection,
    };
  },
  methods: {
    async submit() {
      try {
        this.pending = true;
        await this.$store.dispatch({
          type: 'ui/projectAssets/update',
          projectAssetId: this.projectAssetId,
          formData: this.formData,
        });
      } catch (error) {
        if (error?.response?.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.observer = this.$refs.observer;
          this.addServerErrors(error?.response?.data?.errors || {});
        }
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
